// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__1k9eP","name":"Card_name__3OYPZ","genres":"Card_genres__1y7rO","rick":"Card_rick__2h8_R","img":"Card_img__gMRJu"};